import { Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

interface UsersStepSkelProps {
  donut?: boolean;
}

// Per-step placeholder shown only for the one step section still waiting on
// its own queries - the progressive-load counterpart to UsersSkel.tsx
// (which covers the funnel/KPI/overview phase). See UsersStepSections.tsx.
export default function UsersStepSkel({ donut = false }: UsersStepSkelProps) {
  if (donut) {
    return (
      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={230} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={230} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Stack spacing={2.5}>
      <Skeleton variant="rounded" height={270} />
      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={270} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={270} />
        </Grid>
      </Grid>
    </Stack>
  );
}
